import { PERMISSION_LEVELS } from 'constants/permissions';

export const canEditCaptable = (captable) => {
  if (!captable?.selected || !captable?.selected?.permission) {
    return false;
  }
  return captable?.selected?.permission?.level >= PERMISSION_LEVELS.EDIT;
};
